<!-- <nb-layout>
<nb-layout-column> -->
    <!-- <div class="nb-theme-default"> -->
        <button nbButton 
        [appearance]="appearance" 
        [shape]="shape" [status]="status" 
        [size]="size" [type]="buttontype" 
        [disabled]="disabled"
        (click)="showNotification ? showToast() : ''">
        <div id="icon-container" *ngIf='icon != ""'>
            <nb-icon [icon]="icon"></nb-icon>
            &nbsp;
        </div>
        {{label}}</button>
    <!-- </div> -->
    <!-- </nb-layout-column>
</nb-layout> -->
    
